import React from 'react';
import { FaCaretDown, FaCaretUp, FaSort } from 'react-icons/fa';
import styles from './SortHeader.module.css';

export default function SortHeader({
  column,
  label,
  currentSort,
  currentDir,
  onSort,
  align = 'left'
}) {
  const isActive = currentSort === column;
  const direction = isActive ? currentDir : null;

  const handleClick = () => {
    if (!onSort) return;
    if (!isActive) {
      onSort({ sort: column, dir: 'asc' });
    } else if (direction === 'asc') {
      onSort({ sort: column, dir: 'desc' });
    } else {
      onSort({ sort: '', dir: '' });
    }
  };

  const Icon = !isActive ? FaSort : direction === 'asc' ? FaCaretUp : FaCaretDown;

  return (
    <button
      type="button"
      className={[
        styles.header,
        styles[`align-${align}`],
        isActive ? styles.headerActive : ''
      ].join(' ')}
      onClick={handleClick}
      aria-label={
        isActive
          ? `${label}, sorted ${direction === 'asc' ? 'ascending' : 'descending'}`
          : `Sort by ${label}`
      }
    >
      <span>{label}</span>
      <Icon className={styles.icon} aria-hidden="true" />
    </button>
  );
}
